module.exports = __webpack_public_path__ + "img/head.65c4195b.png";